(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!('IntersectionObserver' in window) || reducido) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function initHero(raiz) {
    (raiz || document).querySelectorAll('.mt-hero').forEach(function (h) {
      if (h.dataset.mtInit) { h.classList.add('mt-listo'); return; }
      h.dataset.mtInit = '1';
      var img = h.querySelector('.mt-hero-media img');
      var listo = function () { requestAnimationFrame(function () { h.classList.add('mt-listo'); }); };
      if (!img || img.complete) listo(); else { img.addEventListener('load', listo); setTimeout(listo, 1500); }
    });
  }

  function initFaq(raiz) {
    (raiz || document).querySelectorAll('.mt-faq-item').forEach(function (item) {
      if (item.dataset.mtInit) return;
      item.dataset.mtInit = '1';
      var btn = item.querySelector('.mt-faq-pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.toggle('mt-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  var parallaxEls = [];
  function initParallax(raiz) {
    if (reducido) return;
    (raiz || document).querySelectorAll('[data-mt-parallax]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      parallaxEls.push(el);
    });
  }
  var pendiente = false;
  function moverParallax() {
    pendiente = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      if (!el.isConnected) return;
      var caja = el.parentElement.getBoundingClientRect();
      if (caja.bottom < 0 || caja.top > vh) return;
      var fuerza = parseFloat(el.dataset.mtParallax || '0.08');
      var progreso = (caja.top + caja.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (progreso * fuerza * -100).toFixed(2) + 'px,0)';
    });
  }
  window.addEventListener('scroll', function () {
    if (!pendiente && parallaxEls.length) { pendiente = true; requestAnimationFrame(moverParallax); }
  }, { passive: true });

  function dinero(centimos, formato) {
    var valor = (centimos / 100);
    var sinDecimales = /amount_no_decimals/.test(formato || '');
    var num = sinDecimales ? Math.round(valor).toLocaleString('es-CL') : valor.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (!formato) return '$' + num;
    return formato.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, num);
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('.mt-prod').forEach(function (prod) {
      if (prod.dataset.mtInit) return;
      prod.dataset.mtInit = '1';

      var principal = prod.querySelector('.mt-galeria-principal img');
      prod.querySelectorAll('.mt-mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = mini.dataset.grande;
            principal.srcset = '';
            principal.style.opacity = '1';
          }, 180);
          prod.querySelectorAll('.mt-mini').forEach(function (m) { m.setAttribute('aria-current', 'false'); });
          mini.setAttribute('aria-current', 'true');
        });
      });

      var cant = prod.querySelector('.mt-cantidad input');
      prod.querySelectorAll('.mt-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value || '1', 10) + parseInt(b.dataset.paso, 10);
          cant.value = Math.max(1, v);
        });
      });

      var datos = prod.querySelector('script[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var formato = prod.dataset.formatoDinero;
      var inputId = prod.querySelector('input[name="id"]');
      var boton = prod.querySelector('[data-mt-boton]');
      var precio = prod.querySelector('[data-mt-precio]');
      var tachado = prod.querySelector('[data-mt-tachado]');
      function actualizar() {
        var elegidas = [];
        prod.querySelectorAll('.mt-opcion').forEach(function (fs) {
          var marcada = fs.querySelector('input:checked');
          elegidas.push(marcada ? marcada.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) {
          boton.disabled = true;
          boton.querySelector('span').textContent = boton.dataset.noDisponible;
          return;
        }
        inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price, formato);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price, formato); tachado.hidden = false; }
          else tachado.hidden = true;
        }
        boton.disabled = !v.available;
        boton.querySelector('span').textContent = v.available ? boton.dataset.texto : boton.dataset.agotado;
        if (v.featured_image && principal) { principal.src = v.featured_image; principal.srcset = ''; }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      prod.querySelectorAll('.mt-opcion input').forEach(function (inp) { inp.addEventListener('change', actualizar); });
    });
  }

  function initTodo(e) {
    var raiz = e && e.target && e.target.querySelectorAll ? e.target : document;
    initHero(raiz);
    initReveals(raiz);
    initFaq(raiz);
    initParallax(raiz);
    initProducto(raiz);
    moverParallax();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
